import { render, staticRenderFns } from "./tele-health-recording.vue?vue&type=template&id=16dc5348&scoped=true&"
import script from "./tele-health-recording.vue?vue&type=script&lang=js&"
export * from "./tele-health-recording.vue?vue&type=script&lang=js&"
import style0 from "./tele-health-recording.vue?vue&type=style&index=0&id=16dc5348&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16dc5348",
  null
  
)

component.options.__file = "tele-health-recording.vue"
export default component.exports